import { useContext } from 'react';

import { LoanActionRunnerStateContext } from '../LoanActionRunnerProvider.constants';

const useLoanActionRunnerContext = () => useContext(LoanActionRunnerStateContext);

export default useLoanActionRunnerContext;
